module.exports = "pegasus_template/assets/preview-13.png";